import React, { useEffect, useState } from "react";
import { Container, Box, Typography } from "@mui/material";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { firestore as db, auth } from "../../firebase";

export default function AdvancedUserChecklist() {
  const [checklists, setChecklists] = useState([]);

  useEffect(() => {
    const q = auth.currentUser
      ? query(
          collection(db, "amc_checklists"),
          where(
            "createdBy",
            "==",
            auth.currentUser.email || auth.currentUser.uid
          )
        )
      : collection(db, "amc_checklists");

    const unsub = onSnapshot(q, (snap) => {
      setChecklists(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  return (
    <Container>
      <Box sx={{ my: 2 }}>
        <Typography variant="h4">AMC Advanced - Your Checklists</Typography>
      </Box>

      <Box sx={{ mt: 2 }}>
        {checklists.map((c) => (
          <Box key={c.id} sx={{ mb: 2, p: 2, border: "1px solid #eee" }}>
            <Typography variant="h6">{c.title}</Typography>
            <Typography variant="body2">{c.description}</Typography>
            {c.media && c.media.length > 0 && (
              <Box sx={{ mt: 1 }}>
                {c.media.map((m) => (
                  <Box key={m.path} sx={{ mb: 1 }}>
                    {m.type.startsWith("image/") && (
                      <img src={m.url} alt={m.name} style={{ maxWidth: 220 }} />
                    )}
                    {m.type.startsWith("audio/") && (
                      <audio controls src={m.url} />
                    )}
                    {m.type.startsWith("video/") && (
                      <video controls src={m.url} style={{ maxWidth: 320 }} />
                    )}
                    <Typography variant="caption">{m.name}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
}
